module.exports = __webpack_public_path__ + "static/media/expand.773aa939.svg";